<template>
    <div>
        <el-row style="">
            <el-row :gutter="40">
                <el-col :span="4">
                    <el-select placeholder="性别"
                               multiple
                               collapse-tags
                               style="width: 100%"
                               size="medium"
                               v-model="form.gender">
                        <el-option label="男"
                                   value="男"></el-option>
                        <el-option label="女"
                                   value="女"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select placeholder="年龄组"
                               multiple
                               collapse-tags
                               size="medium"
                               style="width: 100%"
                               v-model="form.age_group">
                        <el-option label="1.儿童和青少年(18岁以下)"
                                   value="1.儿童和青少年(18岁以下)"></el-option>
                        <el-option label="2.青年(18-44岁)"
                                   value="2.青年(18-44岁)"></el-option>
                        <el-option label="3.中年(45-59岁)"
                                   value="3.中年(45-59岁)"></el-option>
                        <el-option label="4.年轻老年(60-74岁)"
                                   value="4.年轻老年(60-74岁)"></el-option>
                        <el-option label="5.老年(75-89岁)"
                                   value="5.老年(75-89岁)"></el-option>
                        <el-option label="6.长寿老人(大于90岁)"
                                   value="6.长寿老人(大于90岁)"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" >
                    <div style="display: flex;width: 100%;align-items: center">
                        <el-input v-model="form.age_scope.min" placeholder="年龄" type="number" size="medium"   ></el-input>
                        <div>~</div>
                        <el-input v-model="form.age_scope.max" placeholder="年龄" size="medium"  type="number"></el-input>
                    </div>
                </el-col>
                <el-col :span="4">
                    <el-select placeholder="诊断分型"
                               multiple size="medium"
                               style="width: 100%"
                               collapse-tags
                               v-model="form.al_type">
                        <el-option label="AML"
                                   value="AML"></el-option>
                        <el-option label="不详"
                                   value="不详"></el-option>
                        <el-option label="ALL"
                                   value="ALL"></el-option>
                        <el-option label="急性双表型白血病"
                                   value="急性双表型白血病"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select placeholder="诊断亚型"
                               multiple
                               style="width: 100%"
                               collapse-tags
                               size="medium"
                               v-model="form.al_subtype_raw">
                        <el-option v-for="item in al_subtype_rawList" :label="item.label" :key="item.label"
                                   :value="item.label">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-cascader
                            :options="al_subtypeList"
                            v-model="form.al_subtype_merge"
                            :props="props"
                            placeholder="合并亚型"
                            collapse-tags
                            clearable></el-cascader>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px" :gutter="40">
                <el-col :span="4">
                    <el-select placeholder="核型"
                               multiple
                               collapse-tags
                               size="medium"
                               style="width: 100%"
                               v-model="form.hexin">
                        <el-option v-for="item in hexinList" :label="item.label" :key="item.label" :value="item.label">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select placeholder="分子标志"
                               multiple
                               collapse-tags
                               style="width: 100%"
                               size="medium"
                               v-model="form.fenzi">
                        <el-option v-for="item in fenziList" :label="item.label" :key="item.label" :value="item.label">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="form.diag_date"
                               placeholder="就诊年份"
                               multiple
                               collapse-tags
                               style="width: 100%"
                               size="medium"
                               >
                        <el-option v-for="item in YearList" :label="item.label" :key="item.label" :value="item.label">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select placeholder="WHO分型"
                               multiple
                               collapse-tags
                               style="width: 100%"
                               size="medium"
                               v-model="form.who">
                        <el-option v-for="item in whoList" :label="item.label" :key="item.label" :value="item.label">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4" style="display: flex;align-items: center;color: #c0c4cc;font-size: 13px">
                    <span>末次随访时间不超过</span>
                    <el-input style="width: 70%;padding: 0 2px" v-model="form.fup" type="number" size="medium"></el-input>
                    <span>个月</span>
                </el-col>
            </el-row>
            <el-row style="margin-top: 10px">
                <div style="font-size:15px;float: right">
                    <el-select @change="handlGroup" v-model="groupVlaue" clearable placeholder="请选择" style="padding-right: 10px">
                        <el-option
                                v-for="(item,index) in tableData"
                                :key="index"
                                :label="item.name"
                                :value="index">
                        </el-option>
                    </el-select>
                    <el-button
                            @click="addRow"
                            type="primary"
                            icon="el-icon-bottom"
                    >增加为新曲线筛选条件
                    </el-button>
                </div>
            </el-row>
            <el-row style="margin-top: 10px;border-top:1px solid rgb(228 231 237);" :gutter="10">
                <el-col :span="15" style="border-right:1px solid rgb(228 231 237);">
                    <div style="padding-top: 10px;padding-bottom:15px;font-size: 15px;font-weight: bold">
                        图片属性设置
                    </div>
                    <el-col :span="24">
                        <el-form  style="display:flex;"  size="medium" class="imgatt">
                            <el-form-item label="统计指标"  label-width="80px">
                                <el-select placeholder=""
                                           v-model="imgform.tool">
                                    <el-option  label="OS"  value="OS">
                                    </el-option>
                                    <el-option  label="EFS"  value="EFS">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Hazard Ratio(HR)" label-width="140px">
                                <el-select placeholder="Hazard Ratio(HR)"
                                           v-model="imgform.hr">
                                    <el-option  label="是"  value="1">
                                    </el-option>
                                    <el-option  label="否"  value="0">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="95%置信区间" label-width="110px">
                                <el-select placeholder="95%置信区间"
                                           v-model="imgform.ci">
                                    <el-option  label="是"  value="1">
                                    </el-option>
                                    <el-option  label="否"  value="0">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="x轴单位" label-width="80px">
                                <el-select placeholder=""
                                           v-model="imgform.unit">
                                    <el-option  label="天"  value="Days">
                                    </el-option>
                                    <el-option  label="月"  value="Month">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span="24" v-loading="loading" style="text-align: -webkit-center;">
                        <el-row v-loading="loading" element-loading-text="加载中"
                                element-loading-spinner="el-icon-loading"  style="justify-content: center;width: 65%">
                            <pdf
                                    v-if="url"
                                    ref="pdf"
                                    :src="url"
                            >
                            </pdf>
                            <div v-else style="height: 65vh"></div>
                        </el-row>
                    </el-col>
                </el-col>
                <el-col :span="9">
                    <div style="float: right;padding-top: 5px">
                        <el-button type="primary"   @click="handlEAnalyse">分析
                        </el-button>
                        <el-button
                                @click="doDownLoad"
                                type="info"
                                icon="el-icon-download"
                        >下载
                        </el-button>
                    </div>
                    <div style="padding: 10px;font-size: 15px;font-weight: bold">
                        过滤条件
                    </div>
                    <el-row v-for="(items,index) in tableData" :key="index" class="filter" :gutter="10" style="font-size: 14px;">
                        <el-col :span="20" style="padding: 0 5px">
                            <el-col :span="24" style="display: flex;align-items: center">
                                <el-col :span="12">
                                    <div style="display: flex;align-items: center">
                                        <span style="color: #0d0d0e;font-size: 20px">{{index+1}}、</span>
                                        <el-input v-model="items.name" size="small" style="font-size: 14px"></el-input>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <span>病例数：{{items.count}}例</span>
                                    <span> ;中位时间：{{items.median}}</span>
                                </el-col>
                            </el-col>
                            <el-col :span="24" style="padding-left: 25px">
                                <div v-for="(v,index) in items.keyList" :key="index"
                                     >
                                    <div v-if="index==0" style="padding: 5px 30px;word-break: break-all;text-indent: -73px;padding-left: 102px;">
                                        <span style="font-weight: bold">分组条件：</span>
                                        <span >{{index+1}}.{{v}}</span>
                                    </div>
                                    <div v-else style="padding: 5px 30px;word-break: break-all;margin-left: 70px">
                                        <span> {{index+1}}.{{v}}</span>
                                    </div>
                                </div>
                            </el-col>
                        </el-col>
                        <el-col :span="4">
                            <el-button
                                    @click.native.prevent="deleteRow(index, tableData)"
                                    type="danger" plain
                                    >
                                移除
                            </el-button>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-row>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import * as table from '../../config/cyit'
    export default {
        name: "analyse",
            components:{
                pdf
            },

        data() {
            function getNf(){
                var nfOptionsArray = new Array();
                var years= new Date().getFullYear();
                for(var i=years-15;i<=years+3;i++){
                    var anOption = {};
                    anOption.label=i;
                    nfOptionsArray.push(anOption);
                }
                return nfOptionsArray;
            }
            return {
                url: '',
                props: { multiple: true,emitPath:false },
                form: {
                    gender: [],
                    age_group: [],
                    al_type: [],
                    fenzi: [],
                    hexin: [],
                    name: '',
                    diag_date: [],
                    al_subtype_merge: [],
                    age_scope :{min:'',max:''},
                    al_subtype_raw:[],
                    fup: 6,
                },
                YearList: getNf(),
                imgform:{
                    hr:'0',
                    unit:"Days",
                    ci:"1",
                    tool:'OS',
                },
                loading: false,
                whoList:[],
                al_subtype_rawList: table.al_subtype_raw,
                al_subtypeList: table.al_subtypeList,
                fenziList: [],
                hexinList: [],
                tableData: [],
                groupindex:1,
                gname :"",
                groupVlaue:''
            }
        },
        methods: {
            filterAll(data){
                data = JSON.parse(data)
                table.al_subtypeList.forEach(function (item) {
                    var flag = 0
                    item.children.forEach(function (items) {
                        if(!data.includes(items.value)){
                            flag = 1
                        }
                    })
                    if(flag == 0){
                        item.children.forEach(function (items) {
                            var index = data.indexOf(items.value);
                            if(index>=0){
                                data.splice(index,1)
                            }
                        })
                        data.push(item.label)
                    }
                })
                console.log(data)
                return data.join(",")
            },
            handlGroup(v){
                var temp = this.tableData[v]
                for (var key in this.form){
                    if(key == "name" || key == "fup"){
                        if(!this.form[key]){
                            this.form[key] = temp[key]
                        }
                    }else if(key == "age_scope"){
                        if(!this.form[key].min){
                            this.form[key] = temp[key]
                        }
                    }else {
                        if(!this.form[key].length){
                            this.form[key] = temp[key]
                        }
                    }

                }
            },
            guoupname(name){
                var flag = 0
                this.tableData.forEach(function (item) {
                    if(item.name == name){
                        flag = 1
                    }
                })
                if(flag == 1){
                    this.groupindex +=1
                    var gname = `Group${this.groupindex+this.tableData.length}`
                    this.guoupname(gname)
                }else {
                    this.gname = name
                }
            },
            async addRow() {
                try {
                    const resp = await this.$http.post(`/case/select/single/`,this.form)
                    if(resp.data.code == 1){
                        var count = resp.data.count
                        var median = resp.data.median
                        var keyList = []
                        for (let key in this.form) {
                            if (this.form[key].length || key == "age_scope" || key == "fup") {
                                if(key != 'name') {
                                     if(key =="age_scope"){
                                        var min = this.form["age_scope"].min
                                        var max = this.form["age_scope"].max
                                        var temp = ""
                                        if(min && max){
                                            if(parseInt(min)>parseInt(max)){
                                                this.$message.warning("年龄范围不对！")
                                                return
                                            }
                                            temp = min + "<= 年龄 <=" + max
                                        }else if(max && !min){
                                            temp = "年龄 <=" + max
                                        }else if(!max && min){
                                            temp =  min + "<= 年龄"
                                        }
                                        if(temp){
                                            keyList.push(temp)
                                        }
                                    }else if(key == "fup"){
                                        if(this.form[key] ) {
                                            keyList.push("末次随访时间不超过" + this.form[key] + "个月")
                                        }
                                    }
                                    else if (key == 'age_group') {
                                        var t = []
                                        this.form[key].forEach(function (item) {
                                            t.push(item.split('.')[1])
                                        })
                                        keyList.push(t.join(','))
                                    } else if (key == 'al_subtype_merge'){
                                         keyList.push(this.filterAll(JSON.stringify(this.form[key])))
                                    }else {
                                        keyList.push(this.form[key].join(','))
                                    }
                                }
                            }
                        }
                        if (!keyList.length) {
                            this.$message.warning("检索不能全为空！")
                            return
                        }
                        this.guoupname(`Group${this.tableData.length+1}`)
                        this.form.name = this.gname
                        this.form.keyList = keyList
                        var tp = this.form
                        tp['count'] = count
                        tp['median'] = median
                        this.tableData.push(tp);
                        this.form = {
                            gender: [],
                            age_group: [],
                            al_type: [],
                            al_subtype_merge: [],
                            fenzi: [],
                            hexin: [],
                            name: '',
                            diag_date: [],
                            age_scope :{min:'',max:''},
                            fup: 6,
                            al_subtype_raw:[]
                        }
                    }
                } catch (e) {
                    this.$message.error(e.message)
                }
            },
            deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            async getData() {
                var that = this
                that.fenziList = []
                try {
                    const resp = await this.$http.get(`/case/select/`)
                    if (!resp.data) {
                        this.$message.error(resp.data.msg)
                    } else {
                        that.fenziList = resp.data.fenziList
                        that.hexinList = resp.data.hexinList
                        if(resp.data.data.url){
                            that.url = resp.data.data.url
                            that.tableData = resp.data.data.tabledata.filteData
                            that.imgform = resp.data.data.tabledata.form
                        }
                    }
                } catch (e) {
                    this.$message.error(e.message)
                }
            },
            doDownLoad() {
                var that = this
                const link = document.createElement('a')
                this.$http.post('/case/download/', {
                    responseType: 'arraybuffer',
                    xsrfHeaderName: 'Authorization',
                    data:{
                        filteData:that.tableData,
                        form:this.imgform
                    }
                }).then(res => {
                    const blob = new Blob([res.data], {
                        type: 'application/csv'
                    })
                    const objectUrl = URL.createObjectURL(blob)
                    // window.location.href = objectUrl
                    link.href = objectUrl
                    link.download = res.headers['content-disposition'] // 自定义文件名
                    link.click() // 下载文件
                    URL.revokeObjectURL(objectUrl);
                }).catch(() => {
                })
            },
            async handlEAnalyse() {
                var that = this
                that.loading = true
                var data = {
                    filteData:that.tableData,
                    form:this.imgform
                }
                try {
                    const resp = await this.$http.post(`/case/select/`, data)
                    if (resp.data.code ==0) {
                        this.$message.error(resp.data.msg)
                        that.loading = false
                    } else {
                        that.url = resp.data.url
                        that.loading = false
                    }
                } catch (e) {
                    that.loading = false
                    this.$message.error(e.message)
                }
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>
    .filter {
        padding: 5px 0;
    }

    /deep/ .el-form-item--mini .el-form-item__content, /deep/ .el-form-item--mini .el-form-item__label {
        line-height: none;
    }
    .imgatt /deep/ .el-form-item {
        margin-bottom: 0px ;
    }
</style>
